    <!-- =========================================================================================
    File Name: S3UsageReport.vue
    Description: S3 Usage Report page
========================================================================================== -->

<template>
    <div id="demo-card-analytics">
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <vx-card :title="this.$t('MONTHLY_SUM_S3_USAGE_GRAPH')">
                    <div class="pl-5 pt-5">
                        <DatePicker lang="en" type="year" v-model="year" :format="datepickerFormat" width="60"></DatePicker>
                    </div>
                    <div class="pb-0">
                        <vue-apex-charts type=line height=360 :options="chartOptions" :series="series" />
                        <p class="p-3 float-right text-base">{{this.$t("TIME_ZONE_MESSAGE")}}</p>
                        <br/>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VueApexCharts from 'vue-apexcharts'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import moduleReport from "@/store/report/moduleReport.js"

export default {
    components: {
        VueApexCharts,
        DatePicker,
        StatisticsCardLine
    },
    data() {
        return {

            // Excel
            filter: {},
            sorted: {},

            year: this.$moment(new Date).toDate(),
            datepickerFormat: 'YYYY',
            //Chart
            chartOptions: {
                chart: {
                    toolbar: { show: true },
                    dropShadow: {
                        enabled: true,
                        top: 20,
                        left: 2,
                        blur: 6,
                        opacity: 0.20
                    },
                },
                stroke: {
                    curve: 'smooth',
                    width: 4,
                },
                grid: {
                    borderColor: '#ebebeb',
                },
                legend: {
                    show: false,
                },
                colors: ['#F97794'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        inverseColors: false,
                        gradientToColors: ['#7367F0'],
                        shadeIntensity: 1,
                        type: 'horizontal',
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100, 100, 100]
                    },
                },
                markers: {
                    size: 0,
                    hover: {
                        size: 5
                    }
                },
                xaxis: {
                    labels: {
                        style: {
                            cssClass: 'text-grey fill-current',
                        }
                    },
                    axisTicks: {
                        show: false,
                    },

                    axisBorder: {
                        show: false,
                    },
                    categories: [this.$t('JAN'), this.$t('FEB'), this.$t('MAR'), this.$t('APR'), this.$t('MAY'), this.$t('JUN'), this.$t('JUL'), this.$t('AUG'), this.$t('SEP'), this.$t('OCT'), this.$t('NOV'), this.$t('DEC')],
                },
                yaxis: {
                    tickAmount: 5,
                    labels: {
                            style: {
                                cssClass: 'text-grey fill-current',
                            },
                            formatter: function(val) {
                                return val.toLocaleString()+" MB"
                            }
                        },
                },
                tooltip: {
                    x: { show: true }
                }
            },
        }
    },
    created() {
        if (!moduleReport.isRegistered) {
            this.$store.registerModule('dataReport', moduleReport)
            moduleReport.isRegistered = true
        }
        this.$vs.loading()
        this.$store.dispatch("dataReport/fetchS3UsageReport", this.year.getFullYear()).then(() =>{
                this.$vs.loading.close()
        })
        
    },
    watch: {
        year: function() {
            this.$vs.loading()
            this.$store.dispatch("dataReport/fetchS3UsageReport", this.year.getFullYear()).then(() =>{
                this.$vs.loading.close()
            })
        }
    },
    computed: {
        series() {
            return this.$store.state.dataReport.s3UsageReportSeries
        },
    },
    methods: {
    },
}
</script>


<style lang="scss">
#demo-card-analytics {
    .tasks-today-container {
        .tasks-today__task {
            transition: background .15s ease-out;
            .tasks-today__actions {
                display: none;
            }
            &:hover {
                background: rgba(var(--vs-primary), .04);
                .tasks-today__actions {
                    display: flex;
                }
            }
        }
    }
}

#file-download-count-table {
    text-align: center;
}
</style>
